var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgLeadingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_1391_62448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 17.5H1.66675V15.8333H2.50008V3.33333C2.50008 3.11232 2.58788 2.90036 2.74416 2.74408C2.90044 2.5878 3.1124 2.5 3.33341 2.5H15.0001C15.2211 2.5 15.4331 2.5878 15.5893 2.74408C15.7456 2.90036 15.8334 3.11232 15.8334 3.33333V7.5H17.5001V15.8333H18.3334V17.5ZM14.1667 15.8333H15.8334V9.16667H10.8334V15.8333H12.5001V10.8333H14.1667V15.8333ZM14.1667 7.5V4.16667H4.16675V15.8333H9.16675V7.5H14.1667ZM5.83342 9.16667H7.50008V10.8333H5.83342V9.16667ZM5.83342 12.5H7.50008V14.1667H5.83342V12.5ZM5.83342 5.83333H7.50008V7.5H5.83342V5.83333Z",
    fill: "#002244"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1391_62448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgLeadingIcon);
export default __webpack_public_path__ + "static/media/svg_leading_icon.75ae8c8020d870f635ebaac650b4f0ec.svg";
export { ForwardRef as ReactComponent };